import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-start-trading',
  templateUrl: './start-trading.component.html',
  styleUrls: ['./start-trading.component.css']
})
export class StartTradingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
